<template>
  <div>
    <!-- 多张图片的上传组合 -->
    <div class="noalone-box">
      <slot name="coreUpload">
      </slot>
      <div
        class="items"
        v-for="(file, index) in fileListFilter"
        :key="file.uid"
      >
        <el-image
          :src="file.url"
          class="avatar"
          @load="(e) => imageLoaded(e, file)"
        >
        </el-image>
        <div class="image-mask" v-if="file.url">
          <div class="image-view-icon" @click.stop="viewImage(index)"></div>
          <div class="image-delete-icon" v-if="!readonly" @click.stop="deleteUploadHandle(index)"></div>
        </div>
        <p class="upload-text" v-if="isShowTitle">
          <span :title="file.title">{{ file.title }}</span>
          <i
            v-if="isShowCustom"
            class="el-icon-edit-outline edit-icon"
            @click="editTxt(index)"
          ></i>
        </p>
        <div
          class="progress-box"
          v-if="(file.status === 'ready' || file.status === 'uploading') && !file.loaded"
        >
          <!-- 上传中··· -->
          <div class="progress-item">
            <div class="loading-spinner"></div>
            <span>上传中</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fileTitle" class="el-upload__tip">{{ fileTitle }}</div>
    <ImageView :imgViewShow="imgViewShow" :imgList="imgViewList" @closeImgView="closeImgView" v-if="imgViewShow"/>
  </div>
</template>

<script>
import ImageView from './ImageView.vue'

export default {
  name: 'NoAloneBox',
  components: {
    ImageView,
  },
  data() {
    return {
      imgViewShow: false,
      imgViewList: [],
    }
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    isShowTitle: {
      type: Boolean,
      default: false,
    },
    isShowCustom: {
      type: Boolean,
      default: false,
    },
    fileTitle: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deleteUploadHandle(index) {
      this.$emit('deleteUploadHandle', index)
    },

    editTxt(index) {
      this.$emit('editTxt', index)
    },
    // 关闭图片预览
    closeImgView() {
      this.imgViewShow = false
      this.imgViewList = []
    },
    viewImage(index) {
      this.imgViewShow = true
      this.imgViewList = [this.fileListFilter[index].url]
    },
    imageLoaded(e, file) {
      file.loaded = true
    },
  },
  computed: {
    // 上传文件数据处理，过滤掉数组中不是对象或者是对象且无属性的元素
    fileListFilter() {
      // 判断类型是不是数组
      const result = Array.isArray(this.fileList) ? this.fileList : []
      return result.filter((item) => Object.prototype.toString.call(item) === '[object Object]' && Object.keys(item).length !== 0)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.image-mask {
  position: absolute; /* 绝对定位覆盖容器 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* 半透明黑色蒙层，可自定义颜色 */
  opacity: 0; /* 默认透明（隐藏） */
  transition: opacity 0.3s ease; /* 平滑过渡效果 */
  pointer-events: auto; /* 可选：让蒙层不阻挡内容点击（如需点击内容则加） */
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.items:hover .image-mask {
  opacity: 1; /* 完全显示蒙层 */
  .image-view-icon {
    width: 16px;
    height: 16px;
    background: url('../assets/ic-eye@2x.png');
    background-size: cover;
    cursor: pointer;
  }
  .image-delete-icon {
    width: 16px;
    height: 16px;
    background: url('../assets/ic-delete@2x.png');
    background-size: cover;
    margin-left: 20px;
    cursor: pointer;
  }
}
.el-upload__tip {
  color: #86909C;
  font-size: 14px;
  line-height: 22px;
}
</style>
